import { Col, Row } from "antd";
import UploadedDocuments from "../../components/UploadedDocuments/Uploaded Documents";
import { generateRandomData } from "../FlooringVouchers/UserData";
import AgentVoucher from "./AgentVoucher";
import { monthList } from "./UserData";
import { FormatCurrency } from "../../common/Constants";

const ApplicationPreview = (props) => {
  const { applicationData, OwnerIdData, flooringSettingsData } = props;
  const AgentData = generateRandomData();
  const VechilceInfo = applicationData?.vehicleInfo;
  console.log("===================", VechilceInfo)
  const CompanyInfo = applicationData?.companyInfo;
  const AgentDetails = applicationData?.cart;

  // const GetOwnerType = (val) => {
  //   const temp = OwnerIdData?.filter((it) => it.value == val);
  //   if (temp?.length > 0) {
  //     return temp[0]?.label;
  //   } else {
  //     return "";
  //   }
  // };

  const GetOwnerType = (item, val) => {
    const temp = flooringSettingsData[`${item}`]?.filter(
      (it) => it.value == val
    );
    if (temp?.length > 0) {
      return temp[0]?.label;
    } else {
      return "";
    }
  };

  const GetMonth = (val) => {
    const temp = monthList?.filter((it) => it.value == val);
    if (temp?.length > 0) {
      return temp[0]?.label;
    } else {
      return "";
    }
  };

  const AddLabelToFile = (arr, value) => {
    return {
      label: value,
      files: arr,
    };
  };
  return (
    <>
      {applicationData !== undefined &&
        Object.keys(applicationData)?.length > 0 && (
          <section>
            {/* Application Preview */}
            <h2 className="preview-heading">Application Preview</h2>
            <div className="preview-list-block">
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Vehicle Type:</h3>
                  <p>Used Vehicle {`(${VechilceInfo?.flooring_product})`}</p>
                </div>
              </div>
            </div>

            {/* Seller Details */}
            {VechilceInfo?.flooring_product !== "BODYONLY" && (
              <div className="preview-list-block">
                <h2 className="preview-subheading">Seller Details</h2>
                <div className="preview-list-group">
                  <div className="preview-list">
                    <h3>Seller Name:</h3>
                    <p>{VechilceInfo?.seller_name}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Vehicle Details */}
            <div className="preview-list-block">
              <h2 className="preview-subheading">Vehicle Details</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Vehicle Reg No:</h3>
                  <p>{VechilceInfo?.vehicle_reg_no}</p>
                </div>
                <div className="preview-list">
                  <h3>Access Code:</h3>
                  <p>{VechilceInfo?.access_code}</p>
                </div>
                <div className="preview-list">
                  <h3>Make/Model:</h3>
                  <p>{VechilceInfo?.make_model}</p>
                </div>
                <div className="preview-list">
                  <h3>First Reg Date:</h3>
                  <p>{VechilceInfo?.first_reg_date}</p>
                </div>
                <div className="preview-list">
                  <h3>Y.O.M:</h3>
                  <p>{VechilceInfo?.yom}</p>
                </div>
                <div className="preview-list">
                  <h3>OPC Vehicle:</h3>
                  <p>{VechilceInfo?.is_opc_vehicle == 0 ? "NO" : "Yes"}</p>
                </div>
                <div className="preview-list">
                  <h3>Intended Floor Amount:</h3>
                  <p>${VechilceInfo?.intended_floor_amount.slice(
                    0,
                    VechilceInfo?.intended_floor_amount.indexOf(".")
                  )}</p>
                </div>
                <div className="preview-list">
                  <h3>Purchase Price:</h3>
                  <p>${VechilceInfo?.purchase_price.slice(
                    0,
                    VechilceInfo?.purchase_price.indexOf(".")
                  )}</p>
                </div>
                <div className="preview-list">
                  <h3>Flooring Percentage:</h3>
                  <p>{VechilceInfo?.flooring_percentage}%</p>
                </div>
                <div className="preview-list">
                  <h3>{`${VechilceInfo?.flooring_product}`} Expiry:</h3>
                  <p>
                    {/* {VechilceInfo[`${VechilceInfo?.flooring_product}_expiry`]} */}
                    {VechilceInfo?.COE_expiry}
                  </p>
                </div>
              </div>
              <div className="preview-list-group">
                {/* <div className="preview-list">
                  <h3>COE-QP / PQP Paid:</h3>
                  {VechilceInfo[`COE_value`] !== undefined ? (
                    <p>
                      ${VechilceInfo[`COE_value`].slice(
                        0,
                        VechilceInfo[`COE_value`].indexOf(".")
                      )}
                    </p>
                  ) : (
                    <p> </p>
                  )}
                </div> */}
                <div className="preview-list">
                  <h3>COE-QP / PQP Paid:</h3>
                  {VechilceInfo?.COE_value ? (
                    <p>
                      ${String(VechilceInfo.COE_value).slice(
                        0,
                        String(VechilceInfo.COE_value).indexOf(".")
                      )}
                    </p>
                  ) : (
                    <p> </p>
                  )}
                </div>
                <div className="preview-list">
                  <h3>OMV:</h3>
                  <p>${VechilceInfo?.OMV.slice(
                    0,
                    VechilceInfo?.OMV.indexOf(".")
                  )}</p>
                </div>
                {VechilceInfo?.is_vehicle_coe_expiry == 2 && (
                  <div className="preview-list">
                    <h3>PQP Renewal Month:</h3>
                    <p>{GetMonth(VechilceInfo?.PQP_renewal_month)}</p>
                  </div>
                )}

                <div className="preview-list">
                  <h3>Engine No:</h3>
                  <p>{VechilceInfo?.engine_no}</p>
                </div>
                <div className="preview-list">
                  <h3>Chassis No:</h3>
                  <p>{VechilceInfo?.chassis_no}</p>
                </div>
                <div className="preview-list">
                  <h3> ARF Paid:</h3>
                  <p>${VechilceInfo?.min_parf.slice(
                    0,
                    VechilceInfo?.min_parf.indexOf(".")
                  )}</p>
                </div>
                {VechilceInfo?.is_vehicle_coe_expiry == 2 && (
                  <div className="preview-list">
                    <h3>PQP Renewal Amount:</h3>
                    <p>${VechilceInfo?.PQP_amount.slice(
                      0,
                      VechilceInfo?.PQP_amount.indexOf(".")
                    )}</p>
                  </div>
                )}
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Is COE</h3>
                  <p>
                    {GetOwnerType(
                      "is_vehicle_coe_expiry",
                      VechilceInfo?.is_vehicle_coe_expiry
                    )}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>COE Rebate:</h3>
                  <p>${FormatCurrency(VechilceInfo?.coe_rebate)}</p>
                </div>
                <div className="preview-list">
                  <h3>PARF Rebate:</h3>
                  <p>${FormatCurrency(VechilceInfo?.parf_rebate)}</p>
                </div>
                <div className="preview-list">
                  <h3>Total Rebate:</h3>
                  <p>${FormatCurrency(VechilceInfo?.total_rebate)}</p>
                </div>
              </div>
            </div>

            {/* Uploaded Documents */}
            <div className="preview-list-block">
              <h2 className="preview-subheading">Uploaded Documents</h2>
              <section className="preview-upload-data">
                {applicationData?.logcard?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.logcard,
                        "LogCard"
                      )}
                    />
                  </div>
                )}
                {applicationData?.v5_overseas_logcard?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.v5_overseas_logcard,
                        "V5/Overseas Logcard"
                      )}
                    />
                  </div>
                )}
                {applicationData?.sales_agreement?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.sales_agreement,
                        "Sales Agreement"
                      )}
                    />
                  </div>
                )}
                {applicationData?.data_card?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.data_card,
                        "Data Card"
                      )}
                    />
                  </div>
                )}
                {applicationData?.cargo_clearance_permit?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.cargo_clearance_permit,
                        "Cargo Clearance Permit"
                      )}
                    />
                  </div>
                )}
                {applicationData?.bill_of_landing?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.bill_of_landing,
                        "Bill of Landing (BL)"
                      )}
                    />
                  </div>
                )}
                {applicationData?.letter_of_newness?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.letter_of_newness,
                        "Letter of Newness"
                      )}
                    />
                  </div>
                )}
                {applicationData?.logcard?.length > 0 && (
                  <div className="preview-list-group">
                    <UploadedDocuments
                      documents={AddLabelToFile(
                        applicationData?.additional,
                        "Additional Document(s)"
                      )}
                    />
                  </div>
                )}
              </section>
            </div>

            {/* Agent Selection */}
            <div className="preview-list-block">
              <h2 className="preview-subheading">Agent Selection</h2>
              <div className="preview-list-group !block">
                <AgentVoucher userData={AgentDetails} />
              </div>
            </div>

            {/* Company Details */}
            <div className="preview-list-block">
              <h2 className="preview-subheading">Company Details</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Seller Name:</h3>
                  <p>{CompanyInfo?.company}</p>
                </div>
                <div className="preview-list">
                  <h3>Owner ID:</h3>
                  <p>{CompanyInfo?.UEN?.replace(/\d(?=(?:\D*\d){3})/g, "x")}</p>
                </div>
              </div>
            </div>

            <div className="preview-list-block">
              <h2 className="preview-subheading">Documents Uploaded</h2>
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.Company_ACRA,
                    "Company ACRA"
                  )}
                />
              </div>
            </div>

            {/* Point of Contact #1 */}
            <div className="preview-list-block">
              <h2 className="preview-subheading">Point of Contact #1</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Name:</h3>
                  <p>{CompanyInfo?.poc1_name}</p>
                </div>
                <div className="preview-list">
                  <h3>Email:</h3>
                  <p>{CompanyInfo?.poc1_email}</p>
                </div>
                <div className="preview-list">
                  <h3>Contact No:</h3>
                  <p>{CompanyInfo?.poc1_contactno}</p>
                </div>
              </div>
            </div>

            {/* Point of Contact #2 */}
            <div className="preview-list-block">
              <h2 className="preview-subheading">Point of Contact #2</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Name:</h3>
                  <p>{CompanyInfo?.poc2_name}</p>
                </div>
                <div className="preview-list">
                  <h3>Email:</h3>
                  <p>{CompanyInfo?.poc2_email}</p>
                </div>
                <div className="preview-list">
                  <h3>Contact No:</h3>
                  <p>{CompanyInfo?.poc2_contactno}</p>
                </div>
              </div>
            </div>
          </section>
        )}
    </>
  );
};
export default ApplicationPreview;
